<template>
  <div>
    <DxForm
      label-mode="static"
      label-location="top"
    >
      <DxGroupItem
        css-class="content-devx"
        :caption="changeTitle"
        :col-count="2"
      >
        <DxSimpleItem
          name="nameProject"
          :data-field="$t('registerProject.register_project_name')"
          :editor-options="{
            value: newProject.name,
            onValueChanged: onChangeNameProject,
            readOnly: readOnly,
            placeholder: currentProject === '6266cb565842a56069a46607' && !readOnly
              ? 'Agregue un nuevo nombre' : ''
          }"
        />
        <DxSimpleItem
          name="province"
          :data-field="$t('registerProject.register_project_province')"
          editor-type="dxSelectBox"
          :editor-options="{
            items: provinces,
            value: newProject.province,
            displayExpr: 'value',
            valueExpr: 'id',
            searchEnabled: devicePlatform === 'web',
            onValueChanged: onChangeProvince,
            placeholder: '',
            readOnly: readOnly
          }"
        />
        <DxSimpleItem
          :key="itemsClimateKey"
          name="stationClimate"
          :data-field="$t('registerProject.register_project_stationClimate')"
          editor-type="dxSelectBox"
          :editor-options="{
            items: itemsClimate,
            displayExpr: 'source',
            valueExpr: 'id',
            value: newProject.climate_id,
            onValueChanged: onChangeStationClimate,
            searchEnabled: devicePlatform === 'web',
            placeholder: '',
            readOnly: readOnly
          }"
        />
      </DxGroupItem>
      <DxGroupItem
        css-class="content-devx"
        :caption="$t('registerProject.title_groupItem_crop')"
        :col-count="2"
      >
        <DxSimpleItem
          name="crop"
          :data-field="$t('registerProject.register_project_crop')"
          editor-type="dxSelectBox"
          :editor-options="{
            items: listCropGH,
            displayExpr: 'name',
            valueExpr: 'id',
            value: newProject.cultive ? newProject.cultive.crop_id : null,
            onValueChanged: onChangeCrop,
            readOnly: readOnly,
            placeholder: ''
          }"
        />
        <DxSimpleItem
          name="dateTransplanting"
          :data-field="
            $t('registerProject.registerProjectGreenHouse.register_project_dateTransplanting')"
          editor-type="dxDateBox"
          :editor-options="{
            value: newProject.cultive ? newProject.cultive.date_init : null,
            displayFormat: 'dd/MM/yyyy',
            onValueChanged: onChangeDateTransplanting,
            max: newProject.cultive && newProject.cultive.date_end
              ? newProject.cultive.date_end : null,
            dateOutOfRangeMessage: 'La fecha está fuera de rango',
            readOnly: readOnly
          }"
        />
        <DxSimpleItem
          name="CropMedium"
          :data-field="$t('registerProject.registerProjectGreenHouse.register_project_cropMedium')"
          editor-type="dxSelectBox"
          css-class="md-ground"
          :editor-options="{
            items: cropMedium,
            value: newProject.cultive ? newProject.cultive.crop_type : null,
            searchEnabled: devicePlatform === 'web',
            onValueChanged: onChangeCropMedium,
            placeholder: '',
            readOnly: readOnly
          }"
        />
        <DxSimpleItem
          name="end_date_crop"
          :data-field="$t('registerProject.register_project_end_date_crop')"
          editor-type="dxDateBox"
          :editor-options="{
            value: newProject.cultive ? newProject.cultive.date_end : null,
            displayFormat: 'dd/MM/yyyy',
            searchEnabled: devicePlatform === 'web',
            onValueChanged: onChangeEndDateCrop,
            min: newProject.cultive && newProject.cultive.date_init
              ? newProject.cultive.date_init : null,
            dateOutOfRangeMessage: 'La fecha está fuera de rango',
            readOnly: readOnly
          }"
        />
        <DxSimpleItem
          name="CropMedium"
          :data-field="$t('registerProject.registerProjectGreenHouse.register_project_cropMedium')"
          editor-type="dxSelectBox"
          css-class="sm-ground"
          :editor-options="{
            items: cropMedium,
            value: newProject.cultive ? newProject.cultive.crop_type : null,
            searchEnabled: devicePlatform === 'web',
            onValueChanged: onChangeCropMedium,
            placeholder: '',
            readOnly: readOnly
          }"
        />
      </DxGroupItem>
      <DxGroupItem
        css-class="content-devx ground md-ground"
        :caption="$t('registerProject.registerProjectGreenHouse.title_groupItem_floor')"
        :col-count="showField ? 3 : 3"
      >
        <DxGroupItem
          css-class="content-ground-three"
          :col-count="1"
        >
          <DxSimpleItem
            :key="`floor-${keyFloor}`"
            data-field="Suelo"
            :col-span="1"
            editor-type="dxSelectBox"
            :css-class="`bold`"
            :editor-options="{
              items: ground,
              value: newProject.ground ? newProject.ground.ground_id : null,
              displayExpr: 'name',
              valueExpr: 'id',
              searchEnabled: devicePlatform === 'web',
              onValueChanged: onChangeFloor,
              placeholder: '',
              hint: $t('registerProject.registerProjectGreenHouse.float_text.ground'),
              readOnly: readOnly
            }"
          />
          <DxGroupItem
            :css-class="`align-end-field ${showField ? '' : 'hide'}`"
            :col-count="2"
          >
            <DxSimpleItem
              :css-class="`align-end-field ${showField ? '' : 'hide'}`"
              name="nitricNitrogen"
              :data-field="$t('registerProject.registerProjectGreenHouse.register_project_nitric')"
              editor-type="dxNumberBox"
              :editor-options="{
                value: newProject.ground ? newProject.ground.N : null,

                onValueChanged: onChangeNitricNitrogen,
                readOnly: readOnly
              }"
            />
            <DxSimpleItem
              :css-class="`${showField ? '' : 'hide'}`"
              editor-type="dxSelectBox"
              :editor-options="{
                items: unit,
                displayExpr: 'name',
                valueExpr: 'id',
                value: newProject.NitrogesUnit,
                searchEnabled: devicePlatform === 'web',
                onValueChanged: onChangeNitricNitrogenUnit,
                placeholder: '',
                readOnly: readOnly
              }"
            />
          </DxGroupItem>
          <DxGroupItem
            :css-class="`align-end-field ${showField ? '' : 'hide'}`"
            :col-count="2"
          >
            <DxSimpleItem
              :css-class="`${showField ? '' : 'hide'}`"
              name="phosphorus"
              :data-field="
                $t('registerProject.registerProjectGreenHouse.register_project_phosphorus')"
              editor-type="dxNumberBox"
              :editor-options="{
                value:newProject.ground ? newProject.ground.P : null,
                onValueChanged: onChangePhosphorus,
                readOnly: readOnly
              }"
            />
            <DxSimpleItem
              :css-class="`${showField ? '' : 'hide'}`"
              name=""
              editor-type="dxSelectBox"
              :editor-options="{
                items: unit,
                displayExpr: 'name',
                valueExpr: 'id',
                value: newProject.PhosphorusUnit,
                searchEnabled: devicePlatform === 'web',
                onValueChanged: onChangePhosphorusUnit,
                placeholder: '',
                readOnly: readOnly
              }"
            />
          </DxGroupItem>
        </DxGroupItem>
        <DxGroupItem
          css-class="content-ground-one"
          :col-count="1"
        >
          <DxSimpleItem
            name="register_project_analysis_recient"
            :data-field="
              $t('registerProject.registerProjectGreenHouse.register_project_analysis_recient')"
            :col-span="2"
            :css-class="`bold`"
            editor-type="dxSelectBox"
            :editor-options="{
              items: analysis_recient,
              value: newProject.ground
                ? newProject.ground.recent_analysis === ''
                  ? ''
                  : newProject.ground.recent_analysis ? $t('yes') : $t('no')
                : null,
              searchEnabled: false,
              onValueChanged: onChangeAnalysisRecient,
              placeholder: '',
              hint: $t('registerProject.registerProjectGreenHouse.float_text.analysis_recient'),
              readOnly: readOnly
            }"
          />
          <DxGroupItem
            :css-class="`align-end-field ${showField ? '' : 'hide'}`"
            :col-count="2"
          >
            <DxSimpleItem
              :css-class="`${showField ? '' : 'hide'}`"
              name="register_project_analysis_potasio"
              :data-field="
                $t('registerProject.registerProjectGreenHouse.register_project_analysis_potasio')"
              editor-type="dxNumberBox"
              :editor-options="{
                value: newProject.ground ? newProject.ground.K : null,
                onValueChanged: onChangePotasio,
                hint: $t('registerProject.registerProjectGreenHouse.float_text.cations'),
                readOnly: readOnly
              }"
            />
            <DxSimpleItem
              :css-class="`${showField ? '' : 'hide'}`"
              name=""
              editor-type="dxSelectBox"
              :editor-options="{
                items: unit,
                displayExpr: 'name',
                valueExpr: 'id',
                value: newProject.potasioUnit,
                searchEnabled: devicePlatform === 'web',
                onValueChanged: onChangePotasioUnit,
                placeholder: '',
                readOnly: readOnly
              }"
            />
          </DxGroupItem>
          <DxGroupItem
            :css-class="`align-end-field ${showField ? '' : 'hide'}`"
            :col-count="2"
          >
            <DxSimpleItem
              :css-class="`${showField ? '' : 'hide'}`"
              name="register_project_analysis_calcio"
              :data-field="
                $t('registerProject.registerProjectGreenHouse.register_project_analysis_calcio')"
              editor-type="dxNumberBox"
              :editor-options="{
                value: newProject.ground ? newProject.ground.Ca : null,
                onValueChanged: onChangeCalcio,
                hint: $t('registerProject.registerProjectGreenHouse.float_text.cations'),
                readOnly: readOnly
              }"
            />
            <DxSimpleItem
              :css-class="`${showField ? '' : 'hide'}`"
              name=""
              editor-type="dxSelectBox"
              :editor-options="{
                items: unit,
                displayExpr: 'name',
                valueExpr: 'id',
                value: newProject.calcioUnit,
                searchEnabled: devicePlatform === 'web',
                onValueChanged: onChangeCalcioUnit,
                placeholder: '',
                readOnly: readOnly
              }"
            />
          </DxGroupItem>
        </DxGroupItem>
        <DxGroupItem
          :css-class="`content-ground-two  ${!showField ? '' : 'top-ground'}`"
          :col-count="1"
        >
          <DxGroupItem
            :css-class="`${!showField ? '' : 'hide'}`"
            :col-count="1"
          >
            <template>
              <DxItem>
                <template
                  #default
                >
                  <div style="padding-top: 1rem;">
                    <span style="color: steelblue;">
                      Si no dispone de análisis de suelo se usa un suelo medio de invernaderos de Almería.
                    </span>
                  </div>
                </template>
              </DxItem>
            </template>
          </DxGroupItem>
          <DxGroupItem
            :css-class="`align-end-field ${showField ? '' : 'hide'}`"
            :col-count="2"
          >
            <DxSimpleItem
              :css-class="`${showField ? '' : 'hide'}`"
              name="register_project_analysis_magnesio"
              :data-field="
                $t('registerProject.registerProjectGreenHouse.register_project_analysis_magnesio')"
              editor-type="dxNumberBox"
              :editor-options="{
                value: newProject.ground ? newProject.ground.Mg : null,
                onValueChanged: onChangeMagnesio,
                hint: $t('registerProject.registerProjectGreenHouse.float_text.cations'),
                readOnly: readOnly
              }"
            />
            <DxSimpleItem
              :css-class="`${showField ? '' : 'hide'}`"
              name=""
              editor-type="dxSelectBox"
              :editor-options="{
                items: unit,
                displayExpr: 'name',
                valueExpr: 'id',
                value: newProject.magnesioUnit,
                searchEnabled: devicePlatform === 'web',
                onValueChanged: onChangeMagnesioUnit,
                placeholder: '',
                readOnly: readOnly
              }"
            />
          </DxGroupItem>
          <DxGroupItem
            :css-class="
              `align-end-field ${ newProject.ground.recent_analysis === false ? '' : 'hide'}`
            "
            :col-count="1"
          >
            <template>
              <DxItem>
                <template
                  #default
                >
                  <div style="padding-top: 1.5rem;">
                    <span style="color: steelblue;">
                      Valores medios de un invernadero de Almería.
                    </span>
                  </div>
                </template>
              </DxItem>
            </template>
          </DxGroupItem>
        </DxGroupItem>
      </DxGroupItem>
    </DxForm>
    <DxForm
      label-mode="static"
      label-location="top"
      col-count="auto"
      :col-count-by-screen="colCountByScreen"
      :screen-by-width="screenByWidth"
    >
      <DxGroupItem
        css-class="content-devx ground sm-ground"
        :caption="$t('registerProject.registerProjectGreenHouse.title_groupItem_floor')"
        :col-count="2"
      >
        <DxSimpleItem
          :key="`sm-floor-${keyFloor}`"
          data-field="Suelo"
          :col-span="2"
          editor-type="dxSelectBox"
          :css-class="`bold`"
          :editor-options="{
            items: ground,
            value: newProject.ground ? newProject.ground.ground_id : null,
            displayExpr: 'name',
            valueExpr: 'id',
            searchEnabled: devicePlatform === 'web',
            onValueChanged: onChangeFloor,
            placeholder: '',
            hint: $t('registerProject.registerProjectGreenHouse.float_text.ground'),
            readOnly: readOnly
          }"
        />
        <DxSimpleItem
          name="register_project_analysis_recient"
          :data-field="
            $t('registerProject.registerProjectGreenHouse.register_project_analysis_recient')"
          :col-span="2"
          :css-class="`bold`"
          editor-type="dxSelectBox"
          :editor-options="{
            items: analysis_recient,
            value: newProject.ground
              ? newProject.ground.recent_analysis === ''
                ? ''
                : newProject.ground.recent_analysis ? $t('yes') : $t('no')
              : null,
            searchEnabled: false,
            onValueChanged: onChangeAnalysisRecient,
            placeholder: '',
            hint: $t('registerProject.registerProjectGreenHouse.float_text.analysis_recient'),
            readOnly: readOnly
          }"
        />
        <DxGroupItem
          :css-class="`${!showField ? '' : 'hide'}`"
          :col-span="2"
        >
          <template>
            <DxItem>
              <template
                #default
              >
                <div style="padding-top: 1rem;">
                  <span style="color: steelblue;">
                    Si no dispone de análisis de suelo se usa un suelo medio de invernaderos de Almería.
                  </span>
                </div>
              </template>
            </DxItem>
          </template>
        </DxGroupItem>

        <DxGroupItem
          :css-class="`align-end-field ${showField ? '' : 'hide'}`"
          :col-count="2"
          :col-span="2"
        >
          <DxSimpleItem
            :css-class="`align-end-field ${showField ? '' : 'hide'}`"
            name="nitricNitrogen"
            :data-field="$t('registerProject.registerProjectGreenHouse.register_project_nitric')"
            editor-type="dxNumberBox"
            :editor-options="{
              value: newProject.ground ? newProject.ground.N : null,
              onValueChanged: onChangeNitricNitrogen,
              readOnly: readOnly
            }"
          />
          <DxSimpleItem
            :css-class="`align-end-field ${showField ? '' : 'hide'}`"
            editor-type="dxSelectBox"
            :editor-options="{
              items: unit,
              displayExpr: 'name',
              valueExpr: 'id',
              value: newProject.NitrogesUnit,
              searchEnabled: devicePlatform === 'web',
              onValueChanged: onChangeNitricNitrogenUnit,
              placeholder: '',
              readOnly: readOnly
            }"
          />
        </DxGroupItem>
        <DxGroupItem
          :col-span="2"
          :css-class="`align-end-field ${showField ? '' : 'hide'}`"
          :col-count="2"
        >
          <DxSimpleItem
            :css-class="`${showField ? '' : 'hide'}`"
            name="phosphorus"
            :data-field="
              $t('registerProject.registerProjectGreenHouse.register_project_phosphorus')"
            editor-type="dxNumberBox"
            :editor-options="{
              value:newProject.ground ? newProject.ground.P : null,
              onValueChanged: onChangePhosphorus,
              readOnly: readOnly
            }"
          />
          <DxSimpleItem
            :css-class="`${showField ? '' : 'hide'}`"
            name=""
            editor-type="dxSelectBox"
            :editor-options="{
              items: unit,
              displayExpr: 'name',
              valueExpr: 'id',
              value: newProject.PhosphorusUnit,
              searchEnabled: devicePlatform === 'web',
              onValueChanged: onChangePhosphorusUnit,
              placeholder: '',
              readOnly: readOnly
            }"
          />
        </DxGroupItem>

        <DxGroupItem
          :col-span="2"
          :css-class="`align-end-field ${showField ? '' : 'hide'}`"
          :col-count="2"
        >
          <DxSimpleItem
            :css-class="`${showField ? '' : 'hide'}`"
            name="register_project_analysis_potasio"
            :data-field="
              $t('registerProject.registerProjectGreenHouse.register_project_analysis_potasio')"
            editor-type="dxNumberBox"
            :editor-options="{
              value: newProject.ground ? newProject.ground.K : null,
              onValueChanged: onChangePotasio,
              hint: $t('registerProject.registerProjectGreenHouse.float_text.cations'),
              readOnly: readOnly
            }"
          />
          <DxSimpleItem
            :css-class="`${showField ? '' : 'hide'}`"
            name=""
            editor-type="dxSelectBox"
            :editor-options="{
              items: unit,
              displayExpr: 'name',
              valueExpr: 'id',
              value: newProject.potasioUnit,
              searchEnabled: devicePlatform === 'web',
              onValueChanged: onChangePotasioUnit,
              placeholder: '',
              readOnly: readOnly
            }"
          />
        </DxGroupItem>
        <DxGroupItem
          :col-span="2"
          :css-class="`align-end-field ${showField ? '' : 'hide'}`"
          :col-count="2"
        >
          <DxSimpleItem
            :css-class="`${showField ? '' : 'hide'}`"
            name="register_project_analysis_calcio"
            :data-field="
              $t('registerProject.registerProjectGreenHouse.register_project_analysis_calcio')"
            editor-type="dxNumberBox"
            :editor-options="{
              value: newProject.ground ? newProject.ground.Ca : null,
              onValueChanged: onChangeCalcio,
              hint: $t('registerProject.registerProjectGreenHouse.float_text.cations'),
              readOnly: readOnly
            }"
          />
          <DxSimpleItem
            :css-class="`${showField ? '' : 'hide'}`"
            name=""
            editor-type="dxSelectBox"
            :editor-options="{
              items: unit,
              displayExpr: 'name',
              valueExpr: 'id',
              value: newProject.calcioUnit,
              searchEnabled: devicePlatform === 'web',
              onValueChanged: onChangeCalcioUnit,
              placeholder: '',
              readOnly: readOnly
            }"
          />
        </DxGroupItem>
        <DxGroupItem
          :col-span="2"
          :css-class="`align-end-field ${showField ? '' : 'hide'}`"
          :col-count="2"
        >
          <DxSimpleItem
            :css-class="`${showField ? '' : 'hide'}`"
            name="register_project_analysis_magnesio"
            :data-field="
              $t('registerProject.registerProjectGreenHouse.register_project_analysis_magnesio')"
            editor-type="dxNumberBox"
            :editor-options="{
              value: newProject.ground ? newProject.ground.Mg : null,
              onValueChanged: onChangeMagnesio,
              hint: $t('registerProject.registerProjectGreenHouse.float_text.cations'),
              readOnly: readOnly
            }"
          />
          <DxSimpleItem
            :css-class="`${showField ? '' : 'hide'}`"
            name=""
            editor-type="dxSelectBox"
            :editor-options="{
              items: unit,
              displayExpr: 'name',
              valueExpr: 'id',
              value: newProject.magnesioUnit,
              searchEnabled: devicePlatform === 'web',
              onValueChanged: onChangeMagnesioUnit,
              placeholder: '',
              readOnly: readOnly
            }"
          />
        </DxGroupItem>
      </DxGroupItem>
    </DxForm>
    <DxPopUpFloor v-if="selection === 'GreenHouse'" />
    <DxPopUpStation v-if="selection === 'GreenHouse'" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import {
  DxForm,
  DxSimpleItem,
  DxGroupItem,
  DxItem,
} from 'devextreme-vue/form';
import { locale } from 'devextreme/localization';
import DxPopUpFloor from '../popUpFloor/index.vue';
import DxPopUpStation from './popUpStation/index.vue';
import EventBus from '../../../js/event-bus';
import { DEVICE_PLATFORM, MEAN_YEAR } from '../../../js/constants';

export default {

  name: 'RegisterProjectGreenHouse',
  components: {
    DxForm,
    DxGroupItem,
    DxSimpleItem,
    DxPopUpFloor,
    DxPopUpStation,
    DxItem,
  },
  props: {
    listCrop: {
      type: Array,
      default: () => [],
    },
    provinces: {
      type: Array,
      default: () => [],
    },
    keyName: {
      type: String,
      default: '',
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      labelMode: 'hidden',
      labelLocation: 'left',
      showColon: true,
      minColWidth: 300,
      width: null,
      itemsClimate: [],
      itemsClimateKey: 0,
      keyFloor: 0,
      devicePlatform: DEVICE_PLATFORM,
    };
  },
  computed: {
    ...mapState('authentication', ['selection', 'profile']),
    ...mapState('ProjectGreenHouse', ['newProject', 'stationClimate', 'cropMedium', 'methodPlantation', 'floor',
      'analysis_recient', 'unit', 'unitCe', 'listCropGH', 'climate', 'ground']),
    ...mapState('Database', ['currentProject', 'listGroundGh']),
    changeTitle() {
      if (this.readOnly) {
        return 'PROYECTO';
      }
      if (this.keyName === '/openProject/') {
        return this.$t('editProject_title');
      }
      return this.$t('registerProject.title_groupItem_registerProject');
    },
    // eslint-disable-next-line vue/return-in-computed-property
    loadDataMedia() {
      if (this.newProject.ground.recent_analysis === false) {
        this.setAnalysisPotasio(240);
        this.setAnalysisPotasioUnit(this.unit[0].id);
        this.setAnalysisCalcio(1000);
        this.setAnalysisCalcioUnit(this.unit[0].id);
        this.setAnalysisMagnesio(225);
        this.setAnalysisMagnesioUnit(this.unit[0].id);
        this.setAnalysisSodio(58);
        this.setAnalysisSodioUnit(this.unit[0].id);
        this.setPhosphorus(250);
        this.setAnalysisPhosphorusUnit(this.unit[0].id);
        this.setNitricNitrogen(25);
        this.setAnalysisNitrogesUnit(this.unit[0].id);
        this.setCeFloor(3);
        this.setCeFloorUnit(this.unitCe[0].id);
      } else {
        this.setAnalysisPotasio(null);
        this.setAnalysisPotasioUnit(this.unit[0].id);
        this.setAnalysisCalcio(null);
        this.setAnalysisCalcioUnit(this.unit[0].id);
        this.setAnalysisMagnesio(null);
        this.setAnalysisMagnesioUnit(this.unit[0].id);
        this.setAnalysisSodio(null);
        this.setAnalysisSodioUnit(this.unit[0].id);
        this.setPhosphorus(null);
        this.setNitricNitrogen(null);
        this.setAnalysisNitrogesUnit(this.unit[0].id);
        this.setAnalysisPhosphorusUnit(this.unit[0].id);
        this.setCeFloor(null);
        this.setCeFloorUnit(this.unitCe[0].id);
      }
    },
    showField() {
      if (this.readOnly) {
        return true;
      }
      return this.newProject.ground.recent_analysis !== '';
    },
    colCountByScreen() {
      return this.calculateColCountAutomatically
        ? null
        : {
          sm: 1,
          md: 1,
        };
    },
  },
  created() {
    // locale(navigator.language);
    locale('es');
  },
  beforeMount() {
    EventBus.$on('attachedFile', this.setData);
    EventBus.$on('selected-station-green-house', (res) => {
      if (res.id) {
        this.itemsClimate.push({
          id: res.id,
          source: res.source,
        });
        this.itemsClimateKey += 1;
        this.setClimateId(res.id);
        this.setStationType(MEAN_YEAR);
        this.itemsClimateKey += 1;
      }
    });
    EventBus.$on('selected-ground', (id) => {
      if (id) {
        this.setFloor(id);
      }
    });
  },
  beforeDestroy() {
    EventBus.$off('attachedFile');
    EventBus.$off('selected-station-open-air');
    EventBus.$off('selected-ground');
  },
  mounted() {
    if (this.currentProject === '6266cb565842a56069a46607' && !this.readOnly) {
      this.setNameProject('');
    } else {
      this.setNameProject(this.newProject.name);
    }
    this.setData();
  },
  methods: {
    screenByWidth(width) {
      return width < 720 ? 'sm' : 'md';
    },
    getProvinceName(meanYear) {
      return `${meanYear} (El Ejido, Almería)`;
    },
    async setData() {
      const a1 = [{ name: 'Añadir', id: 1 }];
      const arrayConcat = a1.concat(this.listGroundGh);
      this.setGroundConcated(arrayConcat);
      if (!this.newProject.cultive.crop_type) {
        this.newProject.cultive.crop_type = 'Suelo';
      }
      try {
        this.$f7.preloader.show();
        if (this.readOnly) {
          this.setAnalysisPotasioUnit(this.newProject.ground.K_units);
          this.setAnalysisCalcioUnit(this.newProject.ground.Ca_units);
          this.setAnalysisMagnesioUnit(this.newProject.ground.Mg_units);
          this.setAnalysisSodioUnit(this.newProject.ground.Na_units);
          this.setAnalysisPhosphorusUnit(this.newProject.ground.P_units);
          this.setAnalysisNitrogesUnit(this.newProject.ground.N_units);
          this.setCeFloorUnit(this.newProject.ground.ce_units);
        }
        if (this.profile && this.profile.province && !this.newProject.province) {
          this.setProvince(this.profile.province);
          await this.fetchDatabaseClimate(this.profile.province);
        } else if (this.newProject.province) {
          await this.fetchDatabaseClimate(this.newProject.province);
        } else {
          await this.fetchDatabaseClimate();
        }
        const prepareItemsClimate = [...this.stationClimate];
        if (this.climate && this.climate.mean_year) {
          prepareItemsClimate.push({
            id: this.climate.mean_year,
            source: this.getProvinceName(this.climate.mean_year),
          });
        }
        if (this.climate && this.climate.db_climate && this.climate.db_climate.length) {
          this.climate.db_climate.forEach((item) => {
            if (item.project_type === 'GH') {
              prepareItemsClimate.push({
                id: item.id,
                source: item.source,
              });
            }
          });
        }
        this.itemsClimate = prepareItemsClimate;
        if (this.newProject.climate_id === null && this.newProject.weather_source) {
          this.setClimateId('Año medio');
        }
      } catch (error) {
        this.$f7.dialog.alert(this.$t(`${error}`));
      } finally {
        this.$f7.preloader.hide();
      }
    },
    onChangeNameProject(e) {
      if (typeof e.event !== 'undefined') {
        this.setNameProject(e.value);
      }
    },
    onChangeSize(e) {
      if (typeof e.event !== 'undefined') {
        this.setSizeGreenHouse(e.value);
      }
    },
    async onChangeProvince(e) {
      if (typeof e.event !== 'undefined') {
        try {
          this.$f7.preloader.show();
          this.setProvince(e.value);
          await this.fetchDatabaseClimate(e.value);
          const prepareItemsClimate = [...this.stationClimate];
          if (this.climate && this.climate.mean_year) {
            prepareItemsClimate.push({
              id: this.climate.mean_year,
              source: this.getProvinceName(this.climate.mean_year),
            });
          }
          if (this.climate && this.climate.db_climate && this.climate.db_climate.length) {
            this.climate.db_climate.forEach((item) => {
              if (item.project_type === 'GH') {
                prepareItemsClimate.push({
                  id: item.id,
                  source: item.source,
                });
              }
            });
          }
          this.itemsClimate = prepareItemsClimate;
        } catch (error) {
          this.$f7.dialog.alert(this.$t(`${error}`));
        } finally {
          this.$f7.preloader.hide();
        }
      }
    },
    onChangeStationClimate(e) {
      if (typeof e.event !== 'undefined') {
        if (e.value === 'Añadir') {
          this.setEnabledPopUpStation(true);
        } else {
          this.setClimateId(e.value);
          if (e.value === 'Año medio') {
            this.setStation(MEAN_YEAR);
          } else {
            this.setStation(null);
          }
          this.setStationType(MEAN_YEAR);
        }
      }
    },
    onChangeCrop(e) {
      if (typeof e.event !== 'undefined') {
        this.setCrop(e.value);
      }
    },
    onChangeDateTransplanting(e) {
      if (typeof e.event !== 'undefined') {
        this.setDateTransplanting(e.value);
      }
    },
    onChangeCropMedium(e) {
      if (typeof e.event !== 'undefined') {
        this.setCropMedium(e.value);
      }
    },
    onChangeEndDateCrop(e) {
      if (typeof e.event !== 'undefined') {
        this.setDateEndCrop(e.value);
      }
    },
    onChangeFloor(e) {
      if (typeof e.event !== 'undefined') {
        this.setFloor(e.value);
      }
      if (e.value === 1) this.setEnabledPopUpFloor(true);
    },
    onChangeNitricNitrogen(e) {
      if (typeof e.event !== 'undefined') {
        this.setNitricNitrogen(e.value);
      }
    },
    onChangePhosphorus(e) {
      if (typeof e.event !== 'undefined') {
        this.setPhosphorus(e.value);
      }
    },
    onChangeAnalysisRecient(e) {
      if (e.event) {
        if (e.value === '') this.setAnalysisRecient('');
        if (e.value === this.$t('yes')) this.setAnalysisRecient(true);
        if (e.value === this.$t('no')) this.setAnalysisRecient(false);
        this.loadDataMedia;
      }
    },
    onChangeAnalysisPreview(e) {
      if (e.event) {
        if (e.value === '') this.setAnalysisPreview('');
        if (e.value === this.$t('yes')) this.setAnalysisPreview(true);
        if (e.value === this.$t('no')) this.setAnalysisPreview(false);
        this.loadDataMedia;
      }
    },
    onChangePotasio(e) {
      if (typeof e.event !== 'undefined') {
        this.setAnalysisPotasio(e.value);
      }
    },
    onChangePotasioUnit(e) {
      if (typeof e.event !== 'undefined') {
        this.setAnalysisPotasioUnit(e.value);
      }
    },
    onChangeCalcio(e) {
      if (typeof e.event !== 'undefined') {
        this.setAnalysisCalcio(e.value);
      }
    },
    onChangeCalcioUnit(e) {
      if (typeof e.event !== 'undefined') {
        this.setAnalysisCalcioUnit(e.value);
      }
    },
    onChangeMagnesio(e) {
      if (typeof e.event !== 'undefined') {
        this.setAnalysisMagnesio(e.value);
      }
    },
    onChangeMagnesioUnit(e) {
      if (typeof e.event !== 'undefined') {
        this.setAnalysisMagnesioUnit(e.value);
      }
    },
    onChangeSodio(e) {
      if (typeof e.event !== 'undefined') {
        this.setAnalysisSodio(e.value);
      }
    },
    onChangeSodioUnit(e) {
      if (typeof e.event !== 'undefined') {
        this.setAnalysisSodioUnit(e.value);
      }
    },
    onChangeNitricNitrogenUnit(e) {
      if (typeof e.event !== 'undefined') {
        this.setAnalysisNitrogesUnit(e.value);
      }
    },
    onChangePhosphorusUnit(e) {
      if (typeof e.event !== 'undefined') {
        this.setAnalysisPhosphorusUnit(e.value);
      }
    },
    onChangeCeFloor(e) {
      if (typeof e.event !== 'undefined') {
        this.setCeFloor(e.value);
      }
    },
    onChangeCeFloorUnit(e) {
      if (typeof e.event !== 'undefined') {
        this.setCeFloorUnit(e.value);
      }
    },
    ...mapActions('ProjectGreenHouse', ['setNameProject', 'setSizeGreenHouse', 'setProvince', 'setStation', 'setCrop', 'setDateTransplanting', 'setCropMedium',
      'setDateEndCrop', 'setMethodPlantation', 'setFloor', 'setEnabledPopUpFloor', 'setNitricNitrogen', 'setPhosphorus', 'setAnalysisRecient',
      'setAnalysisPotasio', 'setAnalysisPotasioUnit', 'setAnalysisCalcio', 'setAnalysisCalcioUnit', 'setAnalysisMagnesio', 'setAnalysisMagnesioUnit',
      'setAnalysisSodio', 'setAnalysisSodioUnit', 'setAnalysisPreview', 'setAnalysisPhosphorusUnit', 'setAnalysisNitrogesUnit', 'setCeFloor',
      'setCeFloorUnit', 'setEnabledPopUpStation', 'fetchDatabaseClimate', 'setClimateId', 'setStationType',
      'setGroundConcated']),
  },
};
</script>

<style lang="scss">
@import "../registerProjectGreenhouse/registerProject.scss";
@import "../../../css/mixins";

.sm-ground {
  display: block !important;
  @include md {
    display: none !important;
  }
}
.md-ground {
  display: none !important;
  @include md {
    display: block !important;
  }
}
</style>
